export default interface ResourceTypesDependences {
    childResourceTypes: SelectedValues[];
    channels: SelectedValues[];
    cranes: SelectedValues[];
    vehicles: SelectedValues[];
    products: SelectedValues[];
    replacements: SelectedValues[];
    sites: SelectedValues[];
    unknownResources: SelectedValues[];

    [key: string]: SelectedValues[];
}

interface SelectedValues {
    name: string;
    alias: string;
}

export enum DependanceTypes {
    childResourceTypes,
    channels,
    cranes,
    vehicles,
    products,
    replacements,
    sites,
    unknownResources
}

export interface StructuredValues {
    name: string;
    values: SelectedValues[];
}
